import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";

import { getInvitationStatus } from "@/api/auth";
import { AuthLayout } from "@/components/layouts";
import { AuthCard } from "@/components/ui/AuthCard";
import { FormHeader } from "@/components/ui/FormHeader";
import { queryKeys } from "@/queries";

const useInvitationStatus = (invitationToken: string) => {
  return useQuery({
    queryKey: queryKeys.INVITATION_STATUS(invitationToken),
    queryFn: () => getInvitationStatus(invitationToken),
  });
};

export const InvitationView = () => {
  const { invitationToken } = useParams<{ invitationToken: string }>();
  if (!invitationToken) {
    throw new TypeError("Missing param: invitationToken");
  }

  const invitationStatusQuery = useInvitationStatus(invitationToken);

  if (!invitationStatusQuery.isSuccess) {
    return null;
  }

  const { status, redirectUrl } = invitationStatusQuery.data;
  switch (status) {
    case "PASSWORD_SET":
      window.location.href = "/login" + (redirectUrl ? `?redirect_url=${redirectUrl}` : "");
      return null;

    case "VALID":
      window.location.href =
        "/setPassword?invitation=" +
        invitationToken +
        (redirectUrl ? `&redirect_url=${redirectUrl}` : "");
      return null;

    case "ALREADY_LOGGED_IN":
      window.location.href = redirectUrl ?? "/";
      return null;

    case "SSO":
      window.location.href = redirectUrl;
      return null;
  }

  return (
    <AuthLayout title="Manage your invitation">
      {status === "INVALID" && (
        <AuthCard centered>
          <FormHeader
            title="Your invitation is not valid."
            subtitle="Please contact your manager and request a new invitation."
          />
        </AuthCard>
      )}
      {status === "EXPIRED" && (
        <AuthCard centered>
          <FormHeader
            title="Your invitation has expired."
            subtitle="Please contact your manager and request a new invitation."
          />
        </AuthCard>
      )}
    </AuthLayout>
  );
};
